
import {
  Component,
  Prop,
  Vue,
  Watch,
  Model
} from 'vue-property-decorator';
	import {
		handleClipboard
	} from '@/utils/clipboard'
import Dialog from '@/components/dialog.vue';
  import {
    orderSupportreturnExpresswrite,
    orderSupportreturnExpressinit
  } from '@/api/after_sales'
  import uploadImg from "@/components/upload-img.vue"
  import {
    getExpressList,
  } from '@/api/logistics';
@Component({
  name: 'aftersales-order',
  components: {
    'slz-dialog': Dialog,
    uploadImg
  }
})
export default  class AftersalesOrder extends Vue{
  @Prop({default:false}) show!:boolean;
  @Prop({default:''}) SupportNo!:string;
  private sendBackShow = false
  private detailmsg:any = {}

  private sendBackMsg:any={}

  private expressList:any = []
  private loading = false
  private result:any = {}

  @Watch('show')
  private info(val){
    this.sendBackShow = val
    if(val){
      this.init()
      this.togetExpressList()
    }
  }

  private async init(){
    try{
      this.loading = true
      let res = await orderSupportreturnExpressinit({
        SupportNo:this.SupportNo
      })
      if(res.IsSuccess){
        this.result = res.Result
        this.sendBackMsg = {
          SupportNo:this.SupportNo,
          ReturnExpressId:'',
          ReturnExpressNo:'',
          ReturnFreightMoney:'',
          AccountType:0,
          AlipayAccount:res.Result.AlipayAccount,
          AlipayName:res.Result.AlipayName,
          ReturnFreightMoneyImgUrlList:[]
        }
      }
    }finally{
      this.loading = false
    }
  }
  private uploadSuc(list){
    this.sendBackMsg.ReturnFreightMoneyImgUrlList = list
  }
  private async togetExpressList() {
    try {
      const res: any = await getExpressList({});
      this.expressList = res.Result;
    } catch (e) {
      console.log(e)
    }
  }

  private async sendgoods(){
    if(!this.sendBackMsg.ReturnExpressId){
      this.$message.error('请选择物流公司')
      return 
    }
    if(!this.sendBackMsg.ReturnExpressNo){
      this.$message.error('请填写物流单号')
      return 
    }
    if(this.sendBackMsg.ReturnFreightMoney>100){
      this.$message.error('运费金额不能超过100元')
      return 
    }
    if(!String(this.sendBackMsg.AccountType)){
      this.$message.error('请选择运费收款账户')
      return 
    }
    if(this.sendBackMsg.AccountType==0){
      if(!this.sendBackMsg.AlipayAccount){
        this.$message.error('请输入支付宝账号')
        return
      }
      if(!this.sendBackMsg.AlipayName){
        this.$message.error('请输入支付宝姓名')
        return
      }
    }
    try{
      this.sendBackMsg.SupportNo = this.SupportNo
      let res = await orderSupportreturnExpresswrite(this.sendBackMsg)
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.$emit('confirm')
      }
    }finally{
      //
    }
  }


  private close(){
    this.sendBackShow = false
    this.$emit('close')
  }
}
